import React, { useEffect, useRef, useState } from 'react';

import { focusRef } from '../shared/EventHelpers';
import { NO, NOTHING, YES } from '../../../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

/**
 * @param {string} [size] 'sm' or 'lg'. Default is normal.
 * @param {bool} [isSwitch] True removes "Nej" as option.
 */
const EditBoolean = ({ value, setValue, onKeyDown: _onKeyDown, isSwitch, isInvalid, autoFocus, size, setBool }) => {
    const [shouldFocusButton, setShouldFocusButton] = useState(false);
    const noneRef = useRef();
    const noRef = useRef();
    const yesRef = useRef();

    const { t } = useTranslation(['editBoolean', 'shared']);

    const goLeft = () => {
        switch (value) {
            case true:
                setValue(isSwitch ? null : false);
                break;
            case false:
                setValue(null);
                break;
            default:
                break;
        }
        setShouldFocusButton(true);
    };
    const goRight = () => {
        switch (value) {
            case false:
                setValue(true);
                break;
            case null:
                setValue(isSwitch ? true : false);
                break;
            default:
                break;
        }
        setShouldFocusButton(true);
    };

    useEffect(() => {
        if (autoFocus && value === null) {
            setValue(true);
            setShouldFocusButton(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const focusCurrentValue = () => {
        switch (value) {
            case true:
                focusRef(yesRef);
                break;
            case false:
                focusRef(noRef);
                break;
            default:
                focusRef(noneRef);
                break;
        }
    };

    useEffect(() => {
        if (!shouldFocusButton) return;
        focusCurrentValue();
        setShouldFocusButton(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldFocusButton]);

    let noneButtonClass = 'light';
    let noButtonClass = 'light';
    let yesButtonClass = 'light';
    if (value === true) {
        yesButtonClass = 'secondary';
    } else if (value === false) {
        noButtonClass = 'secondary';
    } else if (value === null) {
        noneButtonClass = 'secondary';
    }

    const onKeyDown = (event) => {
        _onKeyDown && _onKeyDown(event);
        // Right arrow
        if (event.keyCode === 39) {
            goRight();
            event.preventDefault();
        }
        // Left arrow
        if (event.keyCode === 37) {
            goLeft();
            event.preventDefault();
        }
    };

    const setClick = (value) => {
        setValue(value);
        if (setBool) {
            setBool(value);
        }
    }

    return (
        <div className='crm-editable-field-wrapper'>
            <div className={`btn-group ${size ? 'btn-group-' + size : ''} edit-type ${isInvalid ? 'invalid' : ''}`} role='group'>
                <button
                    ref={noneRef}
                    tabIndex={value === undefined || value === null ? null : '-1'}
                    type='button'
                    className={`btn btn-${noneButtonClass}`}
                    onClick={() => setClick(null)}
                    onKeyDown={onKeyDown}>
                    {t(NOTHING)}
                </button>
                {!isSwitch && (
                    <button
                        ref={noRef}
                        tabIndex={value === false ? null : '-1'}
                        type='button'
                        className={`btn btn-${noButtonClass}`}
                        onClick={() => setClick(false)}
                        onKeyDown={onKeyDown}>
                        {t(NO, { ns: 'shared' })}
                    </button>
                )}
                <button
                    ref={yesRef}
                    tabIndex={value === true ? null : '-1'}
                    type='button'
                    className={`btn btn-${yesButtonClass}`}
                    onClick={() => setClick(true)}
                    onKeyDown={onKeyDown}>
                        {t(YES, { ns: 'shared' })}
                </button>
            </div>
        </div>
    );
};

export default EditBoolean;
